import React from 'react'
import { buildPropTypes, pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
import { reduxForm, submit } from 'redux-form'
import { Button } from './Button'
import { Row } from './Row'
import { Col } from './Col'
import SectionComponent from 'common-classes/SectionComponent'
import { componentGetCompareProps } from 'common-tools/index'
import { FormBoxContext } from './FormBoxContext'

class FormBoxPlain extends SectionComponent {
  constructor (props) {
    super(props)

    this.state = {
      activeSideEffects: undefined
    }
  }

  static propTypes = buildPropTypes([

  ], {
    onSubmit: pt.func.isRequired,
    onChange: pt.func,
    onFormUnmount: pt.func,
    showButtons: pt.bool.isRequired,
    buttonSetup: pt.shape({
      submitText: pt.string,
      submitColor: pt.string,
      cancelText: pt.string,
      cancelColor: pt.string,
      showCancel: pt.bool
    }),
    destroyOnUnmount: pt.bool.isRequired,
    form: pt.string.isRequired,
    children: pt.node,
    dispatch: pt.func.isRequired,
    onCancel: pt.func,
    handleSubmit: pt.func,
    className: pt.string,
    loading: pt.bool,
    readonly: pt.bool,
    hideLoadingImage: pt.bool.isRequired,
    simpleBody: pt.bool.isRequired,
    sideEffects: pt.string,
    debugMode: pt.bool
  })

  static defaultProps = {
    showButtons: false,
    buttonSetup: {
      submitText: 'Save',
      submitColor: 'primary',
      cancelText: 'Cancel',
      cancelColor: 'secondary',
      showCancel: false
    },
    destroyOnUnmount: true,
    hideLoadingImage: false,
    readonly: false,
    simpleBody: false,
    debugMode: false
  }

  onClick () {
    const { dispatch, form } = this.props
    dispatch(submit(form))
  }

  onCancel () {
    this.props.onCancel()
  }

  onFormUnmount (c) {
    if (!c) {
      const { onFormUnmount } = this.props
      if (_.isFunction(onFormUnmount)) {
        onFormUnmount()
      }
    }
  }

  renderAdvancedBody (buttonSetup, showButtons, loading, testId) {
    const formBody = this.getChild(0)
    const formButtons = this.getChild(1, { submitClick: this.onClick, cancelClick: this.onCancel }, false)

    return (
      <React.Fragment>
        {formBody}
        {showButtons
          ? formButtons ||
          <Row>
            <Col>
              <Button data-tid={`${testId}_submit`} color={buttonSetup.submitColor} disabled={loading} onClick={this.onClick} type='submit'>{buttonSetup.submitText}</Button>{' '}
              <Button data-tid={`${testId}_cancel`} color={buttonSetup.cancelColor} disabled={loading} onClick={this.onCancel}>{buttonSetup.cancelText}</Button>
            </Col>
          </Row>
          : null
        }
      </React.Fragment>
    )
  }

  componentDidMount () {
    const { sideEffects = '' } = this.props
    if (sideEffects !== '') {
      try {
        this.setState({
          activeSideEffects: JSON.parse(sideEffects)
        })
      } catch (error) {

      }
    }
  }

  componentDidUpdate (prevProps, prevState) {
    let sideEffects = componentGetCompareProps('sideEffects', this.props, prevProps, '')

    if (sideEffects.HasChanged) {
      if (sideEffects.Current !== '') {
        try {
          this.setState({
            activeSideEffects: JSON.parse(sideEffects.Current)
          })
        } catch (error) {

        }
      }
    }
  }

  render () {
    const { 'data-tid': testId = '', handleSubmit, onSubmit, loading, buttonSetup, showButtons, className, simpleBody, children, readonly, debugMode } = this.props
    const { activeSideEffects = {} } = this.state

    return (
      <React.Fragment>
        <FormBoxContext.Provider value={{ loading: loading, readonly: readonly, sideEffects: activeSideEffects, debugMode: debugMode }}>
          <form data-tid={testId} className={className} onSubmit={(e) => { handleSubmit(onSubmit); e.preventDefault() }} >
            {simpleBody === true
              ? children
              : this.renderAdvancedBody(buttonSetup, showButtons, loading, testId)
            }
          </form>
        </FormBoxContext.Provider>
        <span ref={this.onFormUnmount} />
      </React.Fragment>
    )
  }
};

export const FormBox = reduxForm({
  enableReinitialize: true
})(FormBoxPlain)

export const FormBox2 = reduxForm({
})(FormBoxPlain)
